
import React from "react";
import { TrackingField } from "./TrackingField";
import { TrackingToggle } from "./TrackingToggle";

interface GoogleAnalyticsSectionProps {
  googleAnalyticsId: string;
  setGoogleAnalyticsId: (value: string) => void;
  googleAnalyticsApiSecret: string;
  setGoogleAnalyticsApiSecret: (value: string) => void;
  isEditing: boolean;
  isEnabled?: boolean;
  setIsEnabled?: (value: boolean) => void;
  isApiEnabled?: boolean;
  setIsApiEnabled?: (value: boolean) => void;
}

export const GoogleAnalyticsSection: React.FC<GoogleAnalyticsSectionProps> = ({
  googleAnalyticsId,
  setGoogleAnalyticsId,
  googleAnalyticsApiSecret,
  setGoogleAnalyticsApiSecret,
  isEditing,
  isEnabled = true,
  setIsEnabled = () => {},
  isApiEnabled = true,
  setIsApiEnabled = () => {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Google Analytics</h3>
        
        {isEditing && (
          <div className="flex space-x-4">
            <TrackingToggle
              id="google-analytics-enabled"
              label="Activer Google Analytics"
              checked={isEnabled}
              onChange={setIsEnabled}
            />
            <TrackingToggle
              id="google-analytics-api-enabled"
              label="Activer l'API Google Analytics"
              checked={isApiEnabled}
              onChange={setIsApiEnabled}
              disabled={!isEnabled}
            />
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TrackingField
          id="google-analytics-id"
          label="Measurement ID"
          value={googleAnalyticsId}
          onChange={setGoogleAnalyticsId}
          isEditing={isEditing}
          placeholder="Exemple: G-XXXXXXXXXX"
          disabled={!isEnabled && isEditing}
        />
        <TrackingField
          id="google-analytics-api-secret"
          label="API Secret"
          value={googleAnalyticsApiSecret}
          onChange={setGoogleAnalyticsApiSecret}
          isEditing={isEditing}
          isPassword={true}
          placeholder="Votre secret API Google Analytics"
          disabled={(!isEnabled || !isApiEnabled) && isEditing}
        />
      </div>
    </div>
  );
};
